import {emptyFiduciarySummary, FiduciarySummary} from "../model/EstateFlowchartTypes";
import {LifeStatus} from "../../ClientManagement/models/MemberType";
import {MemberGroup} from "../../ClientManagement/models/InvestorGroupType";
import {Dispatch} from "redux";
import {createApiError, estateFlowchartApiClient} from "../client/EstateFlowchartApiClient";
import {setFiduciarySummaryState} from "../slices/FiduciarySlice";
import {History} from "history";
import {setGenericErrorModal} from "../slices/EstateFlowChartSlice";

export const isLivingPartner = (familyMembers: MemberGroup): boolean => {
    return familyMembers.partnerMember?.lifeStatus === LifeStatus.Living;
};

export const initializeFiduciaryState = (familyMembers: MemberGroup): FiduciarySummary => {
    return {
        ...emptyFiduciarySummary,
        primaryMember: {
            ...emptyFiduciarySummary.primaryMember,
            assignedToMemberId: familyMembers?.primaryMember?.id,
        },
        partnerMember: isLivingPartner(familyMembers)
            ? {
                ...emptyFiduciarySummary.partnerMember,
                assignedToMemberId: familyMembers.partnerMember ? familyMembers.partnerMember.id : "",
            }
            : undefined,
    };
};

export const handleSaveFiduciaries = async (
    id: string,
    fiduciaries: FiduciarySummary,
    dispatch: Dispatch,
    navigate: boolean,
    history?: History
): Promise<void> => {
    if (fiduciaries.primaryMember) {
        if (fiduciaries.primaryMember?.fiduciaryAssignmentId) {
            await estateFlowchartApiClient.updateFiduciaries(id, fiduciaries)
                .then(response => {
                    dispatch(setFiduciarySummaryState(response));
                    if (navigate && history) {
                        history.push(`/Profile/${id}/ClientProfile/EstateFlowchart`);
                    }
                })
                .catch(error => {
                    dispatch(setGenericErrorModal({
                        isOpen: true,
                        operationId: error?.traceId || error.headers?.get("trace-id"),
                    }));
                });
        } else {
            await estateFlowchartApiClient.createFiduciaries(id, fiduciaries)
                .then(response => {
                    dispatch(setFiduciarySummaryState(response));
                    if (navigate && history) {
                        history.push(`/Profile/${id}/ClientProfile/EstateFlowchart`);
                    }
                })
                .catch(error => {
                    dispatch(setGenericErrorModal({
                        isOpen: true,
                        operationId: error?.traceId || error.headers?.get("trace-id"),
                    }));
                });
        }
    }
};

export const getFiduciaries = async (
    id: string,
    initialFiduciaryState: FiduciarySummary,
    setFiduciaries: (fiduciaries: FiduciarySummary) => void,
    dispatch: Dispatch,
    setInitialFiduciaryState: (fiduciaries: FiduciarySummary) => void
): Promise<void> => {
    return estateFlowchartApiClient.getFiduciaries(id).then((response) => {
        const primaryMember = response.data.primaryMember || initialFiduciaryState.primaryMember;
        const partnerMember = response.data.partnerMember || initialFiduciaryState.partnerMember;
        const fiduciarySummary: FiduciarySummary = {primaryMember, partnerMember};

        setFiduciaries(fiduciarySummary);
        dispatch(setFiduciarySummaryState(fiduciarySummary));
        setInitialFiduciaryState(fiduciarySummary);
    }).catch((error) => {
        throw createApiError(error);
    });
};
